import React from 'react';

const MarquetCards = ({children, classStyles=""}) => {
  return(
    <div className={`marquet--card ${classStyles}`}>
      {children}
    </div>
  )
}

export default MarquetCards;